// src/state/management/employees/initialStates.ts
var EMPLOYEES_SCREEN_FILTERS_INITIAL_STATE = {
  currentStatus: "",
  roleIds: [],
  clockedIn: true,
  period: "today" /* TODAY */,
  startDate: null,
  endDate: null,
  search: ""
};
var EMPLOYEE_DETAILS_SCREEN_FILTERS_INITIAL_STATE = {
  roleIds: EMPLOYEES_SCREEN_FILTERS_INITIAL_STATE.roleIds,
  period: EMPLOYEES_SCREEN_FILTERS_INITIAL_STATE.period,
  startDate: EMPLOYEES_SCREEN_FILTERS_INITIAL_STATE.startDate,
  endDate: EMPLOYEES_SCREEN_FILTERS_INITIAL_STATE.endDate
};
var EMPLOYEE_SHIFT_INITIAL_STATE = {
  shiftId: 0,
  organizationUserId: 0,
  roleId: 0,
  startShift: "",
  endShift: ""
};
var EMPLOYEES_SCREEN_CONTEXT_INITIAL_STATE = {
  user: null,
  users: [],
  setUsers: (newUsers) => newUsers,
  setUser: (newUserId) => newUserId,
  shift: null,
  setShift: (newShiftId) => newShiftId,
  filters: EMPLOYEES_SCREEN_FILTERS_INITIAL_STATE,
  detailsFilters: EMPLOYEE_DETAILS_SCREEN_FILTERS_INITIAL_STATE,
  setDetailsFilters: (newDetailsFilters) => newDetailsFilters,
  setFilters: (newFilters) => newFilters,
  fetchEmployees: () => null,
  fetchShifts: () => null,
  fetchAllDetails: () => null,
  isFetching: false,
  setIsFetching: (newIsFetching) => newIsFetching,
  hasFetched: false,
  setHasFetched: (newHasFetched) => newHasFetched,
  page: -1,
  setPage: (newPage) => newPage,
  totalPages: 0,
  setTotalPages: (newTotalPages) => newTotalPages,
  count: 0,
  setCount: (newCount) => newCount,
  isDetailsFetching: false,
  setIsDetailsFetching: (newIsDetailsFetching) => newIsDetailsFetching,
  hasDetailsFetched: false,
  setHasDetailsFetched: (newHasDetailsFetched) => newHasDetailsFetched,
  detailsPage: -1,
  setDetailsPage: (newDetailsPage) => newDetailsPage,
  detailsTotalPages: 0,
  setDetailsTotalPages: (newDetailsTotalPages) => newDetailsTotalPages,
  detailsCount: 0,
  setDetailsCount: (newDetailsCount) => newDetailsCount,
  shifts: [],
  setShifts: (newShifts) => newShifts,
  employeeSummary: null,
  setEmployeeSummary: (newEmployeeSummary) => newEmployeeSummary,
  sorting: {
    field: null,
    direction: null
  },
  setSorting: (newSorting) => newSorting,
  shiftsSorting: {
    field: null,
    direction: null
  },
  setShiftsSorting: (newSorting) => newSorting
};

export { EMPLOYEES_SCREEN_CONTEXT_INITIAL_STATE, EMPLOYEES_SCREEN_FILTERS_INITIAL_STATE, EMPLOYEE_DETAILS_SCREEN_FILTERS_INITIAL_STATE, EMPLOYEE_SHIFT_INITIAL_STATE };
